// «مطابقة البنك» inside the accounts module (HANDOFF §3
// `/accounts/bank/:accountId`, board accounts/bank--reconcile). Manager+
// (erp-core mounts every bank route behind RequireRole(manager); «إنهاء
// المطابقة» behind owner). Flag erp.accounts; statement import additionally
// behind `erp.bank-import.<parser>` (per parser, from GET /bank/parsers).

import type { RouteObject } from 'react-router-dom';
import { gate, type MenuItem } from '@/app/module-types';

export const BANK_PATH = '/accounts/bank';
const g = gate({ flag: 'erp.accounts', minRole: 'manager' });

export const bankRoutes: RouteObject[] = [
  { path: BANK_PATH, lazy: () => import('./screens/BankIndex').then((m) => ({ Component: m.BankIndexRoute })), handle: g },
  { path: `${BANK_PATH}/:accountId`, lazy: () => import('./screens/BankReconcile').then((m) => ({ Component: m.BankReconcileRoute })), handle: g },
];

export const bankMenu: MenuItem[] = [{ key: 'bank', label: 'مطابقة البنك', to: BANK_PATH, flag: 'erp.accounts', minRole: 'manager' }];

/** Deep link to an account's reconciliation month (the period check's «افتح المطابقة» uses the same shape). */
export const bankHref = (accountId: string, month?: string) => `${BANK_PATH}/${accountId}${month ? `?period=${month}` : ''}`;
